module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-wrap"
  }, [(_vm.ordered) ? _c('ol', _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "draggable": ("" + _vm.draggable)
      },
      on: {
        "dragstart": function($event) {
          _vm.handleDragStart(index, $event)
        }
      }
    }, [_vm._v("\n\t\t    " + _vm._s(item.text) + "\n\t\t")])
  })) : _vm._e(), _vm._v(" "), (!_vm.ordered) ? _c('ul', _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "draggable": ("" + _vm.draggable)
      },
      on: {
        "dragstart": function($event) {
          _vm.handleDragStart(index, $event)
        }
      }
    }, [_vm._v("\n\t\t    " + _vm._s(item.text) + "\n\t\t")])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54c6bd32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoList.vue
// module id = 622
// module chunks = 0